/* The Quiet Visions Museum: pin wheel.
   No dependencies. Reads the pins from the markup inside [data-qvm], so in Shopify the
   list can be rendered by Liquid and this file ships unchanged as a theme asset. */
(function () {
  'use strict';

  function boot(root) {
    if (root.__qvm) return;
    root.__qvm = true;

    var stage = root.querySelector('.qvm__stage');
    var wheel = root.querySelector('.qvm__wheel');
    var head = root.querySelector('.qvm__head');
    var title = root.querySelector('.qvm__title');
    var titleFit = root.querySelector('.qvm__title-fit');
    var spot = root.querySelector('.qvm__spot');
    var label = root.querySelector('.qvm-label');
    var labelName = root.querySelector('.qvm-label__name');
    var labelDetail = root.querySelector('.qvm-label__detail');
    var labelDate = root.querySelector('.qvm-label__date');
    var hint = root.querySelector('.qvm-hint');
    var hintText = root.querySelector('.qvm-hint__text');
    var live = root.querySelector('[data-qvm-live]');

    // ------------------------------------------------------------------ tuning
    var CFG = {
      stepDeg: 32,        // angle between neighbouring pins on the drum
      spacing: 0.82,      // arc distance between pins, in pin units
      perspective: 1.5,   // camera distance, in drum radii
      unitOfStage: 0.48,  // pin size relative to the space under the title
      drag: 1.2,          // seconds; air-like drag, bigger = flicks carry further
      brake: 5,           // pins/s²; steady bearing friction that brings it to a stop
      capture: 0.14,      // pins; how close the magnet has to be before it grabs
      springK: 230,       // magnet stiffness for the final click
      stepK: 150,         // softer spring for one-pin moves (arrows, notches, gentle flicks)
      springZeta: 0.72,   // damping (1 = no overshoot)
      detent: 0.36,       // 0..1; how much each pin catches under your finger
      wheelIdle: 110,     // ms of wheel silence that ends a scroll gesture
      maxSpeed: 42,       // pins per second
      visible: 2.75,      // pins further than this from centre are hidden
      labelW: 320,
      labelGap: 56,
      labelBottom: 64,    // px between the bottom of the screen and the name on phones (clears the view switch)
      labelRoom: 88       // px kept free above that for the name, subtitle and date on phones
    };

    // data-qvm-fill (the Shopify section): take all the height below the store header and keep
    // the page itself from scrolling, so the museum behaves like one screen
    var fill = root.hasAttribute('data-qvm-fill');
    function fitHeight() {
      if (!fill) return;
      var top = root.getBoundingClientRect().top + (window.pageYOffset || 0);
      root.style.height = Math.max(520, window.innerHeight - top) + 'px';
    }
    if (fill) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      window.scrollTo(0, 0);
      fitHeight();
      window.addEventListener('resize', fitHeight);
      window.addEventListener('load', fitHeight);
    }

    var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
    var reduced = reduceMQ.matches;
    var coarse = window.matchMedia('(pointer: coarse)').matches;

    // ------------------------------------------------------------------ pins
    var sources = Array.prototype.slice.call(wheel.querySelectorAll('.qvm-pin'));
    var N = sources.length;
    if (!N) return;

    // The drum needs six slots so a pin never appears twice at once; repeat short lists.
    var slotEls = sources.slice();
    while (slotEls.length < 6) {
      sources.forEach(function (s) {
        var c = s.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        wheel.appendChild(c);
        slotEls.push(c);
      });
    }
    var M = slotEls.length;

    function layer(tag, cls) {
      var el = document.createElement(tag);
      el.className = 'qvm-pin__layer ' + cls;
      el.setAttribute('aria-hidden', 'true');
      if (tag === 'canvas') { el.width = 0; el.height = 0; }   // no pixels until the pin comes near
      return el;
    }

    var items = slotEls.map(function (el, slot) {
      var img = el.querySelector('.qvm-pin__img');
      var ar = parseFloat(el.getAttribute('data-ar')) || 1.6;
      var shadowA = layer('canvas', 'qvm-pin__shadow');
      var shadowC = layer('canvas', 'qvm-pin__shadow');
      var blur2 = layer('canvas', 'qvm-pin__blur');
      var blur1 = layer('canvas', 'qvm-pin__blur');
      [shadowA, shadowC, blur2, blur1].forEach(function (c) { el.insertBefore(c, img); });
      var sheen = layer('span', 'qvm-pin__sheen');
      var band = document.createElement('i');
      sheen.appendChild(band);
      el.appendChild(sheen);
      var thumb = img.getAttribute('data-src') || img.getAttribute('src');
      img.addEventListener('load', wake);
      img.addEventListener('error', wake);
      return {
        el: el, img: img, ar: ar, slot: slot, index: slot % N,
        name: el.getAttribute('data-name') || '',
        detail: el.getAttribute('data-detail') || '',
        category: el.getAttribute('data-category') || '',
        released: el.getAttribute('data-released') || '',
        shadowA: shadowA, shadowC: shadowC, blur1: blur1, blur2: blur2, sheen: sheen, band: band,
        thumb: thumb, full: img.getAttribute('data-full') || thumb,
        src: img.getAttribute('src') ? 'thumb' : null, fullReq: null, fullFailed: false,
        pad: {}, w: 0, h: 0, shown: false, ready: false
      };
    });

    // ------------------------------------------------------------------ pre-rendered blur + shadow
    // Blurring live with CSS filters every frame is slow on phones, so each pin gets two
    // pre-blurred copies and two pre-rendered shadows once. Scrolling only cross-fades them.
    var CTX_FILTER = typeof CanvasRenderingContext2D !== 'undefined' &&
      'filter' in CanvasRenderingContext2D.prototype;

    function paintBlur(canvas, img, ar, baseW, radius) {
      var w = baseW, h = Math.round(baseW / ar), pad = Math.ceil(radius * 3);
      canvas.width = w + pad * 2;
      canvas.height = h + pad * 2;
      var ctx = canvas.getContext('2d');
      if (CTX_FILTER) {
        ctx.filter = 'blur(' + radius + 'px)';
        ctx.drawImage(img, pad, pad, w, h);
      } else {
        // No canvas filters (older Safari): shrink hard, then scale back up smoothly.
        var s = Math.max(2, radius);
        var t = document.createElement('canvas');
        t.width = Math.max(2, Math.round(canvas.width / s));
        t.height = Math.max(2, Math.round(canvas.height / s));
        var tc = t.getContext('2d');
        tc.imageSmoothingQuality = 'high';
        tc.drawImage(img, pad / s, pad / s, w / s, h / s);
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(t, 0, 0, canvas.width, canvas.height);
      }
      return pad / w;
    }

    function paintShadow(canvas, img, ar, baseW, blur) {
      var w = baseW, h = Math.round(baseW / ar), pad = Math.ceil(blur * 1.6) + 2;
      canvas.width = w + pad * 2;
      canvas.height = h + pad * 2;
      var ctx = canvas.getContext('2d');
      var off = canvas.width + 50;
      // Draw the pin off-canvas and keep only its shadow, so the shadow follows the pin's real outline.
      ctx.shadowColor = '#000';
      ctx.shadowBlur = blur;
      ctx.shadowOffsetX = off;
      ctx.drawImage(img, pad - off, pad, w, h);
      return pad / w;
    }

    function prepare(it) {
      var img = it.img;
      it.pad.b1 = paintBlur(it.blur1, img, it.ar, 260, 4);
      it.pad.b2 = paintBlur(it.blur2, img, it.ar, 110, 5);
      it.pad.sa = paintShadow(it.shadowA, img, it.ar, 200, 22);
      it.pad.sc = paintShadow(it.shadowC, img, it.ar, 360, 5);
      var url = 'url("' + it.thumb + '")';
      it.sheen.style.webkitMaskImage = url;
      it.sheen.style.maskImage = url;
      it.ready = true;
      sizeItem(it);
    }

    function freeLayers(it) {
      [it.blur1, it.blur2, it.shadowA, it.shadowC].forEach(function (c) { c.width = 0; c.height = 0; });
      it.sheen.style.webkitMaskImage = '';
      it.sheen.style.maskImage = '';
      it.ready = false;
    }

    // ------------------------------------------------------------------ loading window
    // Only the pins near the front of the wheel hold a decoded image. All of them at once is
    // hundreds of megabytes, which makes a phone browser kill the page. Pins in range show the
    // small copy; the pin in focus (and the one a spin is about to land on) swaps in the full
    // photo; blur and shadow layers exist only for the few pins on screen.
    var WIN = { thumb: 10, thumbDrop: 14, layers: 3.4, layersDrop: 5, full: 0.6, fullDrop: 1.6 };
    var work = false;

    function wake() { work = true; kick(); }

    function loaded(it) { return !!it.src && it.img.complete && it.img.naturalWidth > 0; }

    function setSrc(it, which) {
      it.src = which;
      it.img.src = which === 'full' ? it.full : it.thumb;
    }

    function requestFull(it) {
      if (it.src !== 'thumb' || it.fullReq || it.fullFailed || it.full === it.thumb) return;
      var im = new Image();
      it.fullReq = im;
      function done(ok) {
        if (it.fullReq !== im) return;
        it.fullReq = null;
        if (!ok) { it.fullFailed = true; return; }
        // already decoded, so the swap shows on the next frame with no blank flash
        if (it.src === 'thumb') { setSrc(it, 'full'); wake(); }
      }
      // Once it has downloaded, give the browser a moment to decode it off-screen, but never wait
      // on decode() alone: some browsers hold that promise until the next paint.
      im.onload = function () {
        var settled = false;
        function fin() { if (!settled) { settled = true; done(true); } }
        if (im.decode) im.decode().then(fin, fin);
        setTimeout(fin, im.decode ? 180 : 0);
      };
      im.onerror = function () { done(false); };
      im.fetchPriority = 'high';
      im.src = it.full;
    }

    function dropFull(it) {
      it.fullReq = null;
      if (it.src === 'full') setSrc(it, 'thumb');
    }

    function unload(it) {
      dropFull(it);
      if (it.ready) freeLayers(it);
      if (it.src) { it.img.removeAttribute('src'); it.src = null; }
    }

    function manage() {
      var fast = Math.abs(vel) > 7;
      var target = mode === 'coast' ? coastTarget : mode === 'snap' ? snapTarget : null;
      var targetSlot = target === null ? -1 : mod(target, M);
      var queue = [];
      for (var i = 0; i < M; i++) {
        var it = items[i], d = Math.abs(wrap(it.slot - pos));
        if (d > WIN.thumbDrop) { if (it.src) unload(it); continue; }
        if (d <= WIN.thumb && !it.src) setSrc(it, 'thumb');
        if ((d <= WIN.full && !fast) || it.slot === targetSlot) requestFull(it);
        else if (d > WIN.fullDrop) dropFull(it);
        if (d > WIN.layersDrop) { if (it.ready) freeLayers(it); }
        else if (d <= WIN.layers && !it.ready && loaded(it)) queue.push([d, it]);
      }
      // build the nearest pins' layers first, a few per frame so a spin never stutters
      queue.sort(function (a, b) { return a[0] - b[0]; });
      var t0 = now(), budget = fast ? 3 : 8, n = 0;
      while (n < queue.length && (n === 0 || now() - t0 < budget)) prepare(queue[n++][1]);
      work = n < queue.length;
    }

    // Warm the browser cache with every small copy in the background, nearest pins first, so a
    // fast spin never reaches a pin whose photo hasn't downloaded. Nothing here stays decoded.
    function prefetch() {
      var order = items.slice().sort(function (a, b) { return Math.abs(wrap(a.slot)) - Math.abs(wrap(b.slot)); });
      var next = 0, active = 0;
      (function more() {
        while (active < 2 && next < order.length) {
          var im = new Image();
          im.fetchPriority = 'low';
          active++;
          im.onload = im.onerror = function () { active--; more(); };
          im.src = order[next++].thumb;
        }
      })();
    }

    // ------------------------------------------------------------------ haptics
    // Android: Vibration API. iOS 18+ Safari has no vibration API, but toggling a native
    // <input switch> plays the system tick, so a hidden one is clicked instead.
    var haptics = (function () {
      var last = 0;
      var vib = coarse && typeof navigator.vibrate === 'function';
      var ios = /iP(hone|ad|od)/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      var lbl = null;
      if (!vib && ios) {
        lbl = document.createElement('label');
        lbl.setAttribute('aria-hidden', 'true');
        lbl.style.cssText = 'position:fixed;left:-200px;top:0;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none';
        var input = document.createElement('input');
        input.type = 'checkbox';
        input.setAttribute('switch', '');
        input.tabIndex = -1;
        lbl.appendChild(input);
        document.body.appendChild(lbl);
      }
      return function (strong) {
        var t = performance.now();
        if (t - last < (strong ? 0 : 42)) return;
        last = t;
        if (vib) { try { navigator.vibrate(strong ? 14 : 7); } catch (e) { /* blocked */ } }
        else if (lbl) lbl.click();
      };
    })();

    // ------------------------------------------------------------------ geometry
    var W = 0, H = 0, headH = 0, U = 0, R = 0, STEP = 0, P = 0, cx = 0, cy = 0;
    var pxPerItem = 300, wide = true, shadowStrength = 1, pinMaxW = 660, pinMaxH = Infinity;

    // Size the headline so its longest line runs most of the width of the screen, but never taller
    // than about a fifth of it. One line on wide screens, two on phones.
    function fitTitle() {
      if (!title || !titleFit) return;
      var stacked = W / H < 0.9;
      title.classList.toggle('is-stacked', stacked);
      title.style.fontSize = '100px';
      var cs = getComputedStyle(head);
      var avail = head.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var box = titleFit.getBoundingClientRect();
      if (!box.width) return;
      var size = 0.84 * 100 * avail / box.width;
      size = Math.min(size, 100 * H * (stacked ? 0.2 : 0.17) / box.height, 200);
      title.style.fontSize = Math.floor(size * 10) / 10 + 'px';
    }

    function layout() {
      W = root.clientWidth;
      H = root.clientHeight;
      if (!W || !H) return;
      fitTitle();
      headH = head.offsetHeight;
      wide = W >= 880;

      var maxAr = 1;
      items.forEach(function (it) { maxAr = Math.max(maxAr, it.ar); });
      var room = H - headH;
      // Every pin gets the same area, so square, wide and tall pins carry equal weight.
      if (wide) {
        pinMaxW = Math.min(W * 0.46, 660);
        U = Math.min(room * CFG.unitOfStage, pinMaxW / Math.sqrt(maxAr), 480);
      } else {
        // Phones: size from a typical pin shape and the whole screen height (the wheel runs up under
        // the headline), so the wheel fills the screen. The few extra-wide pins are scaled down to
        // fit the width on their own in sizeItem.
        pinMaxW = W - 32;
        U = Math.min(H * 0.42, (W - 32) / Math.sqrt(1.45), 480);
      }

      STEP = CFG.stepDeg * Math.PI / 180;
      R = CFG.spacing * U / STEP;
      P = CFG.perspective * R;
      cx = wide ? W / 2 - (CFG.labelW + CFG.labelGap) / 2 : W / 2;
      // the wheel sits in the middle of the page; the headline overlaps its top until the visitor
      // starts turning it (on phones a touch higher, leaving room for the name underneath)
      cy = H * 0.5;
      pinMaxH = Infinity;
      if (!wide) {
        // Phones: the pin in front sits in the clear space between the headline and the name under
        // the wheel, so neither the words nor the soft fades behind them ever cover it. (The pins
        // above and below may still pass under the headline.) Very tall pins shrink to fit.
        var clearTop = headH + 14, clearBottom = H - CFG.labelBottom - CFG.labelRoom - 14;
        cy = Math.min((clearTop + clearBottom) / 2, H * 0.5);
        // (÷1.03: the pin lifts 3% when it settles)
        pinMaxH = Math.max(120, 2 * Math.min(cy - clearTop, clearBottom - cy) / 1.03);
      }

      wheel.style.perspective = P.toFixed(1) + 'px';
      wheel.style.perspectiveOrigin = cx.toFixed(1) + 'px ' + cy.toFixed(1) + 'px';
      stage.style.setProperty('--cx', cx + 'px');
      stage.style.setProperty('--cy', cy + 'px');
      root.style.setProperty('--head-h', headH + 'px');

      var th = STEP, z = R * (Math.cos(th) - 1);
      pxPerItem = R * Math.sin(th) * P / (P - z);

      shadowStrength = parseFloat(getComputedStyle(root).getPropertyValue('--shadow-strength')) || 1;
      items.forEach(sizeItem);
      if (labelItem) placeLabel(labelItem);
      if (focused) placeFocus();
    }

    function placeCanvas(c, padFrac, w, h) {
      if (padFrac == null) return;
      var p = padFrac * w, s = c.style;
      s.left = -p + 'px';
      s.top = -p + 'px';
      s.width = (w + 2 * p) + 'px';
      s.height = (h + 2 * p) + 'px';
    }

    function sizeItem(it) {
      if (!U) return;
      var k = Math.sqrt(it.ar), w = U * k, h = U / k, s = it.el.style;
      if (w > pinMaxW) { h *= pinMaxW / w; w = pinMaxW; }
      if (h > pinMaxH) { w *= pinMaxH / h; h = pinMaxH; }
      it.w = w;
      it.h = h;
      s.width = w + 'px';
      s.height = h + 'px';
      s.left = (cx - w / 2) + 'px';
      s.top = (cy - h / 2) + 'px';
      placeCanvas(it.blur1, it.pad.b1, w, h);
      placeCanvas(it.blur2, it.pad.b2, w, h);
      placeCanvas(it.shadowA, it.pad.sa, w, h);
      placeCanvas(it.shadowC, it.pad.sc, w, h);
    }

    // ------------------------------------------------------------------ helpers
    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
    function smooth(a, b, x) { var t = clamp((x - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }
    function wrap(o) { return o - M * Math.round(o / M); }
    function mod(n, m) { return ((n % m) + m) % m; }
    function now() { return performance.now(); }
    function setO(el, v) {
      v = Math.round(v * 1000) / 1000;
      if (el._o !== v) { el._o = v; el.style.opacity = v; }
    }

    // Detents: a soft staircase between finger travel and wheel travel. Near each pin the
    // wheel moves a little slower than your finger, between pins a little faster, so every
    // pin catches for a moment as it passes the centre.
    var TAU = Math.PI * 2;
    function detent(x) { return x - CFG.detent / TAU * Math.sin(TAU * x); }
    function detentSlope(x) { return 1 - CFG.detent * Math.cos(TAU * x); }
    function undetent(p) {
      var x = p;
      for (var i = 0; i < 5; i++) x -= (detent(x) - p) / detentSlope(x);
      return x;
    }

    // ------------------------------------------------------------------ state
    var pos = -4;           // continuous wheel position, in pins; integer = a pin dead centre
    var vel = 0;            // pins per second
    var mode = 'idle';      // idle | drag | wheel | coast | snap
    var snapTarget = 0, snapK = CFG.springK, coastTarget = 0, coastBrake = CFG.brake;
    var lift = 0, liftVel = 0;
    var lastIdx = Math.round(pos);
    var userMoved = false;
    var labelItem = null, labelPos = 0, labelShown = false;
    var centerItem = null;

    // ------------------------------------------------------------------ physics
    function beginSnap(target, k) {
      snapTarget = target;
      snapK = k || CFG.springK;
      mode = 'snap';
    }

    // Coasting follows dv/dt = -v/drag - brake: drag lets fast flicks run long, the brake
    // makes slow ones stop in finite time instead of crawling. How far a spin at speed v
    // travels with a given brake:
    function coastDistance(v, brake) {
      var T = CFG.drag;
      if (brake <= 1e-6) return T * v;
      return T * (v - brake * T * Math.log(1 + v / (brake * T)));
    }

    // Let go of the wheel at velocity v. Short moves click straight into the nearest pin.
    // Real flicks coast, with the brake adjusted a hair so they come to rest exactly on a pin.
    function release(v) {
      v = clamp(v, -CFG.maxSpeed, CFG.maxSpeed);
      var dir = v < 0 ? -1 : 1, sp = Math.abs(v);
      var target = Math.round(pos + dir * coastDistance(sp, CFG.brake));
      // any deliberate flick reaches at least the next pin in its direction
      if (sp >= 0.9) target = dir > 0 ? Math.max(target, Math.ceil(pos + 0.02)) : Math.min(target, Math.floor(pos - 0.02));
      var dist = (target - pos) * dir;
      vel = v;
      if (dist < 1.5) { beginSnap(target, dist > 0.5 ? CFG.stepK : CFG.springK); return; }
      var maxDist = coastDistance(sp, 0);
      if (dist >= maxDist) { target -= dir; dist -= 1; }
      if (dist < 1.5) { beginSnap(target, CFG.stepK); return; }
      var lo = 0, hi = 400;
      for (var i = 0; i < 40; i++) {
        var mid = (lo + hi) / 2;
        if (coastDistance(sp, mid) > dist) lo = mid; else hi = mid;
      }
      coastBrake = (lo + hi) / 2;
      coastTarget = target;
      mode = 'coast';
    }

    function stepBy(dir) {
      var base = mode === 'snap' ? snapTarget : Math.round(pos + vel * 0.05);
      userMoved = true;
      beginSnap(base + dir, CFG.stepK);
      kick();
    }

    var wheelRaw = 0, lastWheelT = 0, wheelSamples = [], lastWheelDiscrete = false;

    function step(dt) {
      var prev = pos;
      switch (mode) {
        case 'coast': {
          var T = CFG.drag, d = vel < 0 ? -1 : 1, sp = Math.abs(vel), bT = coastBrake * T;
          var e = Math.exp(-dt / T);
          var sp2 = (sp + bT) * e - bT;
          if (sp2 <= 0) {
            // stopped inside this frame
            pos += d * (T * sp - bT * T * Math.log(1 + sp / bT));
            vel = 0;
          } else {
            pos += d * (T * (sp + bT) * (1 - e) - bT * dt);
            vel = d * sp2;
          }
          if (Math.abs(coastTarget - pos) < CFG.capture || vel === 0) beginSnap(coastTarget);
          break;
        }
        case 'snap': {
          var K = snapK, zeta = reduced ? 1 : CFG.springZeta, C = 2 * zeta * Math.sqrt(K);
          var left = dt;
          while (left > 0) {
            var h = Math.min(left, 1 / 240);
            vel += (-K * (pos - snapTarget) - C * vel) * h;
            pos += vel * h;
            left -= h;
          }
          if (Math.abs(pos - snapTarget) < 2e-3 && Math.abs(vel) < 0.04) settle();
          break;
        }
        case 'wheel': {
          var want = detent(wheelRaw);
          pos += (want - pos) * (1 - Math.exp(-dt / 0.045));
          vel = dt > 0 ? (pos - prev) / dt : 0;
          if (now() - lastWheelT > CFG.wheelIdle) {
            var sum = 0;
            wheelSamples.forEach(function (s) { sum += s.d; });
            var span = wheelSamples.length ? (wheelSamples[wheelSamples.length - 1].t - wheelSamples[0].t) / 1000 : 0;
            var v = sum / Math.max(span, 0.05);
            release(v * detentSlope(wheelRaw));
          }
          break;
        }
        case 'drag': {
          var dv = dt > 0 ? (pos - prev) / dt : 0;
          vel += (dv - vel) * (1 - Math.exp(-dt / 0.05));
          break;
        }
      }

      // a tick each time a pin passes the pointer, like the flapper on a prize wheel
      var idx = Math.round(pos);
      if (idx !== lastIdx) {
        lastIdx = idx;
        if (userMoved) { haptics(false); recede(); }
      }

      if (labelShown && Math.abs(pos - labelPos) > 0.04) hideLabel();

      // the lit pin lifts off the wheel when it comes to rest, and sets down when touched
      if (mode === 'idle') {
        var lk = 150, lc = 2 * (reduced ? 1 : 0.6) * Math.sqrt(lk);
        liftVel += (-lk * (lift - 1) - lc * liftVel) * dt;
        lift += liftVel * dt;
        if (Math.abs(lift - 1) < 5e-4 && Math.abs(liftVel) < 5e-3) { lift = 1; liftVel = 0; }
      } else {
        lift += (0 - lift) * (1 - Math.exp(-dt / 0.07));
        liftVel = 0;
      }
    }

    function settle() {
      pos = snapTarget;
      vel = 0;
      mode = 'idle';
      // keep the numbers small after long spins
      var wrapBy = Math.floor(pos / M) * M;
      pos -= wrapBy;
      snapTarget -= wrapBy;
      lastIdx = Math.round(pos);
      if (userMoved) haptics(true);
      showLabel(items[mod(Math.round(pos), M)]);
    }

    // ------------------------------------------------------------------ render
    function render() {
      if (!U) return;
      manage();
      var speedBlur = reduced ? 0 : clamp((Math.abs(vel) - 3) / 9, 0, 1.15);
      var best = 99, center = null;

      for (var i = 0; i < M; i++) {
        var it = items[i];
        var o = wrap(it.slot - pos);
        var ad = Math.abs(o);
        if (ad > CFG.visible) {
          if (it.shown) { it.el.style.display = 'none'; it.shown = false; }
          continue;
        }
        if (!it.shown) { it.el.style.display = 'block'; it.shown = true; }
        if (ad < best) { best = ad; center = it; }

        var th = o * STEP;
        var y = R * Math.sin(th), z = R * (Math.cos(th) - 1);
        var focus = 1 - smooth(0, 1, ad);
        var lk = lift * focus;
        var sc = 1 + (reduced ? 0.01 : 0.03) * lk;
        it.el.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,' + z.toFixed(2) + 'px) rotateX(' +
          (-th).toFixed(4) + 'rad) scale(' + sc.toFixed(4) + ')';
        it.el.style.zIndex = String(100 - Math.round(ad * 10));
        setO(it.el, 1 - smooth(1.55, CFG.visible, ad));

        // focus: sharp at the centre, two pre-blurred copies further out (and at speed)
        var bd = Math.max(ad, speedBlur);
        setO(it.img, it.ready ? 1 - smooth(0.28, 0.95, bd) : 1);
        setO(it.blur1, it.ready ? smooth(0.02, 0.45, bd) * (1 - smooth(1.3, 1.95, bd)) : 0);
        setO(it.blur2, it.ready ? smooth(1.0, 1.45, bd) : 0);

        // shadows: a soft ambient pool plus a tight contact shadow; lifting deepens one, softens the other
        if (it.ready) {
          setO(it.shadowA, (0.17 + 0.13 * lk) * shadowStrength * (1 - smooth(0.6, 1.9, ad)));
          it.shadowA.style.transform = 'translate3d(0,' + ((0.05 + 0.055 * lk) * it.h).toFixed(2) + 'px,0) scale(' +
            (0.95 + 0.07 * lk).toFixed(4) + ')';
          setO(it.shadowC, (0.34 - 0.16 * lk) * shadowStrength * (1 - smooth(0.12, 0.7, Math.max(ad, speedBlur))));
          it.shadowC.style.transform = 'translate3d(0,' + ((0.012 + 0.012 * lk) * it.h).toFixed(2) + 'px,0)';
        }

        // sheen: a reflection slides across the enamel as the pin turns toward you, and leaves as it locks in
        if (!reduced && it.ready) {
          var t = clamp(ad / 1.15, 0, 1);
          it.band.style.transform = 'translate3d(' + (250 - t * 380).toFixed(1) + '%,0,0) skewX(-14deg)';
          setO(it.sheen, 0.42 * (1 - smooth(0.85, 1.3, ad)));
        } else {
          setO(it.sheen, 0);
        }
      }

      if (center !== centerItem) {
        if (centerItem) centerItem.el.classList.remove('is-center');
        if (center) center.el.classList.add('is-center');
        centerItem = center;
      }
      setO(spot, 0.6 + 0.4 * lift);
    }

    // ------------------------------------------------------------------ loop
    var raf = 0, lastT = 0;
    function frame(t) {
      var dt = Math.min((t - lastT) / 1000, 1 / 30);
      lastT = t;
      if (dt > 0) step(dt);
      render();
      var busy = mode !== 'idle' || lift !== 1 || work;
      raf = busy ? requestAnimationFrame(frame) : 0;
    }
    function kick() {
      if (!raf) {
        lastT = now();
        raf = requestAnimationFrame(frame);
      }
    }

    // ------------------------------------------------------------------ wall label
    function placeLabel(it) {
      if (wide) {
        label.classList.remove('is-stacked');
        label.style.width = CFG.labelW + 'px';
        label.style.maxWidth = '';
        var x = cx + it.w * 1.03 / 2 + CFG.labelGap;
        label.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0) translateY(-50%)';
      } else {
        label.classList.add('is-stacked');
        label.style.width = 'max-content';
        label.style.maxWidth = (W - 32) + 'px';
        var lw = label.offsetWidth;
        var bottom = H - CFG.labelBottom - label.offsetHeight;
        label.style.transform = 'translate3d(' + ((W - lw) / 2).toFixed(1) + 'px,' + bottom.toFixed(1) + 'px,0)';
      }
    }

    // the release date under the subtitle, e.g. "April 2023" (styled as small capitals in the CSS)
    function fillDate(el, released) {
      if (el) el.textContent = released || '';
    }
    function spokenDate(it) {
      return it.released ? ', ' + it.released : '';
    }

    function showLabel(it) {
      labelItem = it;
      labelPos = pos;
      labelName.textContent = it.name;
      if (labelDetail) labelDetail.textContent = it.detail;
      fillDate(labelDate, it.released);
      placeLabel(it);
      label.classList.remove('is-shown');
      void label.offsetWidth;
      label.classList.add('is-shown');
      labelShown = true;
      if (live) live.textContent = it.name + (it.detail ? ', ' + it.detail : '') + spokenDate(it) + ', ' + (it.index + 1) + ' of ' + N;
    }

    function hideLabel() {
      labelShown = false;
      label.classList.remove('is-shown');
    }

    // ------------------------------------------------------------------ input: first touch
    var hinted = true;
    // once the visitor actually turns the wheel, the headline steps back so the pins lead
    var receded = false;
    function recede() {
      if (receded) return;
      receded = true;
      root.classList.add('is-receding');
      // drop behind the pins once the fade is done (see .is-receding in the CSS)
      setTimeout(function () { root.classList.add('is-receded'); }, reduced ? 0 : 560);
    }

    function interacted() {
      userMoved = true;
      if (hinted) {
        hinted = false;
        if (hint) hint.classList.add('is-gone');
      }
    }
    if (hintText && coarse) hintText.textContent = 'Swipe to spin';

    // ------------------------------------------------------------------ input: drag / flick
    var drag = null;

    stage.addEventListener('pointerdown', function (e) {
      if (drag || (e.pointerType === 'mouse' && e.button !== 0)) return;
      try { stage.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      stage.classList.add('is-grabbing');
      drag = {
        id: e.pointerId, x0: e.clientX, y0: e.clientY,
        raw0: undetent(pos), raw: null, moved: false,
        samples: [{ t: e.timeStamp, y: e.clientY }]
      };
      // a hand on the wheel stops it
      mode = 'drag';
      vel = 0;
      interacted();
      kick();
    });

    stage.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dy = e.clientY - drag.y0;
      if (!drag.moved && Math.abs(dy) + Math.abs(e.clientX - drag.x0) > 6) drag.moved = true;
      drag.raw = drag.raw0 - dy / pxPerItem;
      pos = detent(drag.raw);
      var s = drag.samples;
      s.push({ t: e.timeStamp, y: e.clientY });
      while (s.length > 2 && e.timeStamp - s[0].t > 120) s.shift();
      kick();
    });

    function endDrag(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag;
      drag = null;
      stage.classList.remove('is-grabbing');

      if (!d.moved) {
        // a tap: turn to the pin that was tapped, or settle back onto the current one
        var hit = e.type === 'pointerup' ? document.elementFromPoint(e.clientX, e.clientY) : null;
        var li = hit && hit.closest ? hit.closest('.qvm-pin') : null;
        var target = Math.round(pos);
        for (var i = 0; li && i < M; i++) {
          if (items[i].el === li) { target = Math.round(pos + wrap(items[i].slot - pos)); break; }
        }
        vel = 0;
        beginSnap(target, target === Math.round(pos) ? CFG.springK : CFG.stepK);
        kick();
        return;
      }

      // release speed from the last ~80ms of movement; none if the finger paused first
      var s = d.samples, last = s[s.length - 1], v = 0;
      if (e.timeStamp - last.t < 60 && s.length > 1) {
        var first = s[0];
        for (var j = 0; j < s.length; j++) { if (last.t - s[j].t <= 80) { first = s[j]; break; } }
        var dt = (last.t - first.t) / 1000;
        if (dt > 0.008) v = -(last.y - first.y) / dt / pxPerItem;
      }
      release(v * detentSlope(d.raw == null ? d.raw0 : d.raw));
      kick();
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);
    stage.addEventListener('lostpointercapture', function (e) { if (drag && e.pointerId === drag.id) endDrag(e); });

    // ------------------------------------------------------------------ input: mouse wheel / trackpad
    root.addEventListener('wheel', function (e) {
      if (view !== 'wheel') return;   // the grid scrolls natively; the focused pin closes on its own
      e.preventDefault();
      var t = now();
      var d = Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
      if (e.deltaMode === 1) d *= 40;
      else if (e.deltaMode === 2) d *= H;
      if (!d) return;
      var gap = t - lastWheelT;
      lastWheelT = t;
      interacted();

      // A notched mouse wheel moves one pin per notch; a trackpad or free-spinning wheel moves freely.
      var wd = e.wheelDeltaY || e.wheelDelta || 0;
      var discrete = e.deltaMode !== 0 ||
        (Math.abs(d) >= 50 && wd !== 0 && Math.abs(wd) % 120 === 0 && (gap > 250 || lastWheelDiscrete));
      lastWheelDiscrete = discrete;

      if (discrete) {
        stepBy(d > 0 ? 1 : -1);
        return;
      }
      if (mode !== 'wheel') {
        mode = 'wheel';
        wheelRaw = undetent(pos);
        wheelSamples.length = 0;
      }
      wheelRaw += d / pxPerItem;
      wheelSamples.push({ t: t, d: d / pxPerItem });
      while (wheelSamples.length > 1 && t - wheelSamples[0].t > 100) wheelSamples.shift();
      kick();
    }, { passive: false });

    // ------------------------------------------------------------------ input: keyboard + buttons
    function onKey(e) {
      if (view !== 'wheel' || switching) return;
      var k = e.key, dir = 0;
      if (k === 'ArrowDown' || k === 'ArrowRight' || k === 'PageDown' || k === 'j') dir = 1;
      else if (k === 'ArrowUp' || k === 'ArrowLeft' || k === 'PageUp' || k === 'k') dir = -1;
      if (!dir || e.metaKey || e.ctrlKey || e.altKey) return;
      e.preventDefault();
      interacted();
      stepBy(dir);
    }
    stage.addEventListener('keydown', onKey);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (focused) closeFocus();
        else if (view === 'grid') closeGrid();
        return;
      }
      // standalone page: arrows work without focusing the wheel first
      if (e.target === document.body) onKey(e);
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-step]'), function (btn) {
      btn.addEventListener('click', function () {
        interacted();
        stepBy(parseInt(btn.getAttribute('data-step'), 10) || 1);
      });
    });

    // ------------------------------------------------------------------ views: wheel, grid, focused pin
    var gridEl = root.querySelector('.qvm-grid');
    var gridInner = root.querySelector('.qvm-grid__inner');
    var focusEl = root.querySelector('.qvm-focus');
    var focusLabel = root.querySelector('.qvm-focus__label');
    var focusName = root.querySelector('.qvm-focus__name');
    var focusDetail = root.querySelector('.qvm-focus__detail');
    var focusDate = root.querySelector('.qvm-focus__date');
    var focusClose = root.querySelector('.qvm-focus__close');
    var viewBtns = Array.prototype.slice.call(root.querySelectorAll('[data-view]'));
    var view = 'wheel', switching = false, closing = false;
    var gridItems = null, focused = null, focusFlyer = null, headTimer = 0;
    var EASE = 'cubic-bezier(0.2, 0.8, 0.2, 1)';

    function rectOf(el) {
      var o = root.getBoundingClientRect(), r = el.getBoundingClientRect();
      return { x: r.left - o.left, y: r.top - o.top, w: r.width, h: r.height };
    }
    function grow(r, k) { return { x: r.x - r.w * (k - 1) / 2, y: r.y - r.h * (k - 1) / 2, w: r.w * k, h: r.h * k }; }
    // the transform that lays a flyer whose box is d exactly over rect r
    function T(r, d) {
      return 'translate(' + (r.x - d.x).toFixed(1) + 'px,' + (r.y - d.y).toFixed(1) + 'px) scale(' +
        (r.w / d.w).toFixed(4) + ',' + (r.h / d.h).toFixed(4) + ')';
    }
    function onScreen(r) { return r.y + r.h > -40 && r.y < H + 40; }
    function speed(ms) { return reduced ? ms * 0.5 : ms; }

    function makeFlyer(src, box, parent, cls) {
      var f = document.createElement('img');
      f.className = 'qvm-flyer' + (cls ? ' ' + cls : '');
      f.alt = '';
      f.draggable = false;
      f.src = src;
      f.style.left = box.x + 'px';
      f.style.top = box.y + 'px';
      f.style.width = box.w + 'px';
      f.style.height = box.h + 'px';
      (parent || root).appendChild(f);
      return f;
    }
    function shownSrc(it) { return it.src === 'full' ? it.full : it.thumb; }

    function setPressed() {
      viewBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-view') === view)); });
    }

    function moveHead(animate) {
      var y = view === 'grid' ? -gridEl.scrollTop : 0;
      if (animate) {
        head.style.transition = 'transform ' + speed(550) + 'ms ' + EASE;
        clearTimeout(headTimer);
        headTimer = setTimeout(function () { head.style.transition = ''; }, speed(600));
      }
      head.style.transform = y ? 'translate3d(0,' + y.toFixed(1) + 'px,0)' : '';
    }

    // One tile per pin, built the first time the grid opens. Every pin gets the same area,
    // like on the wheel, scaled so the widest and the tallest pins both fit their square.
    function buildGrid() {
      if (gridItems) return;
      var minAr = Infinity, maxAr = 0;
      for (var i = 0; i < N; i++) { minAr = Math.min(minAr, items[i].ar); maxAr = Math.max(maxAr, items[i].ar); }
      var k = Math.min(0.96 / Math.sqrt(maxAr), 0.96 * Math.sqrt(minAr));
      gridItems = [];
      var counts = {};
      for (var c = 0; c < N; c++) counts[items[c].category] = (counts[items[c].category] || 0) + 1;
      for (var j = 0; j < N; j++) {
        var it = items[j];
        // each category opens with its own heading, like a room in a museum
        if (it.category && (j === 0 || items[j - 1].category !== it.category)) {
          var hd = document.createElement('h2');
          hd.className = 'qvm-grid__heading';
          hd.textContent = it.category;
          var ct = document.createElement('span');
          ct.className = 'qvm-grid__count';
          ct.textContent = counts[it.category] + (counts[it.category] === 1 ? ' pin' : ' pins');
          hd.appendChild(ct);
          gridInner.appendChild(hd);
        }
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'qvm-grid__item';
        b.setAttribute('aria-label', it.name + (it.detail ? ', ' + it.detail : '') + spokenDate(it));
        var im = document.createElement('img');
        im.alt = '';
        im.draggable = false;
        im.decoding = 'async';
        im.loading = 'lazy';
        im.width = +it.img.getAttribute('width') || 1200;
        im.height = +it.img.getAttribute('height') || Math.round(1200 / it.ar);
        im.style.width = (k * Math.sqrt(it.ar) * 100).toFixed(2) + '%';
        im.src = it.thumb;
        b.appendChild(im);
        b.addEventListener('click', openFocus.bind(null, j));
        gridInner.appendChild(b);
        gridItems.push({ el: b, img: im, item: it, index: j });
      }
      gridEl.addEventListener('scroll', function () { if (view === 'grid' && !switching) moveHead(false); }, { passive: true });
    }

    // the wheel pins that will be on screen around slot s, and where each sits in the grid
    function pairs(s, fromWheel) {
      var out = [];
      for (var o = -2; o <= 2; o++) {
        var t = s + o;
        if (t < 0 || t >= N) continue;           // never fly across the seam from the last pin to the first
        var it = items[t], gi = gridItems[it.index];
        if (!it.shown) continue;
        var cell = rectOf(gi.img);
        if (!onScreen(cell)) continue;
        var spot = rectOf(it.el);
        out.push({ it: it, gi: gi, lead: o === 0, op: parseFloat(it.el.style.opacity || '1'),
          from: fromWheel ? spot : cell, to: fromWheel ? cell : spot });
      }
      return out;
    }

    function openGrid() {
      if (view !== 'wheel' || switching) return;
      switching = true;
      view = 'grid';
      setPressed();
      interacted();
      recede();
      hideLabel();
      drag = null;
      // stop the wheel on the nearest pin
      pos = Math.round(pos);
      vel = 0;
      mode = 'idle';
      lift = 1;
      render();
      var c = items[mod(Math.round(pos), M)];
      buildGrid();
      gridEl.getAnimations().forEach(function (a) { a.cancel(); });
      gridEl.hidden = false;
      root.classList.add('is-grid');
      var g0 = gridItems[c.index];
      gridEl.scrollTop = Math.max(0, g0.el.offsetTop + g0.el.offsetHeight / 2 - gridEl.clientHeight / 2);
      moveHead(true);

      // the pins on the wheel fly out to their places in the grid
      var fl = pairs(c.slot, true);
      var flying = fl.map(function (p) { return p.gi; });
      // the rest of the grid ripples in, outward from the pin you were on
      var r0 = rectOf(g0.el);
      gridItems.forEach(function (g) {
        if (flying.indexOf(g) !== -1) { g.img.style.visibility = 'hidden'; return; }
        var r = rectOf(g.el);
        if (!onScreen(r)) return;
        var d = Math.abs(r.y - r0.y) / r0.h + Math.abs(r.x - r0.x) / r0.w * 0.5;
        g.el.animate([{ opacity: 0, transform: 'translateY(22px) scale(0.9)' }, { opacity: 1, transform: 'none' }],
          { duration: speed(560), delay: speed(140 + d * 55), easing: EASE, fill: 'backwards' });
      });
      stage.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(0.97)' }],
        { duration: speed(300), easing: 'ease-out', fill: 'forwards' });

      var left = fl.length;
      function landed() {
        if (--left > 0) return;
        stage.style.visibility = 'hidden';
        fl.forEach(function (p) { p.it.el.style.visibility = ''; });
        switching = false;
      }
      if (!left) { left = 1; landed(); }
      fl.forEach(function (p) {
        p.it.el.style.visibility = 'hidden';
        var f = makeFlyer(shownSrc(p.it), p.to, root, p.lead ? 'is-lead' : '');
        var frames = p.lead && !reduced
          ? [{ transform: T(p.from, p.to), easing: 'cubic-bezier(0.25, 0.75, 0.3, 1)' },
             { transform: T(grow(p.to, 1.06), p.to), offset: 0.68, easing: 'cubic-bezier(0.4, 0, 0.4, 1)' },
             { transform: 'none' }]
          : [{ transform: T(p.from, p.to), opacity: p.lead ? 1 : p.op, filter: p.lead ? 'none' : 'blur(5px)' },
             { transform: 'none', opacity: 1, filter: p.lead ? 'none' : 'blur(0px)' }];
        var a = f.animate(frames, { duration: speed(p.lead ? 640 : 560), delay: p.lead ? 0 : speed(50),
          easing: p.lead && !reduced ? 'linear' : EASE, fill: 'backwards' });
        a.onfinish = function () { p.gi.img.style.visibility = ''; f.remove(); landed(); };
      });
    }

    // the tile closest to the middle of the screen: that's the pin the wheel comes back to
    function middleTile() {
      var mid = gridEl.clientHeight / 2, best = null, bd = Infinity;
      gridItems.forEach(function (g) {
        var r = g.el.getBoundingClientRect(), o = gridEl.getBoundingClientRect();
        var dy = r.top + r.height / 2 - o.top - mid, dx = r.left + r.width / 2 - (o.left + o.width / 2);
        var d = dy * dy + dx * dx * 0.25;
        if (d < bd) { bd = d; best = g; }
      });
      return best;
    }

    function closeGrid() {
      if (view !== 'grid' || switching) return;
      if (focused) closeFocus(true);
      switching = true;
      var g0 = middleTile();
      var c = items[g0.index];
      view = 'wheel';
      setPressed();
      // put the wheel on that pin, standing still
      pos = c.slot;
      vel = 0;
      mode = 'idle';
      lift = 1;
      liftVel = 0;
      lastIdx = Math.round(pos);
      stage.getAnimations().forEach(function (a) { a.cancel(); });
      stage.style.visibility = '';
      render();

      var fl = pairs(c.slot, false);
      fl.forEach(function (p) { p.it.el.style.visibility = 'hidden'; p.gi.img.style.visibility = 'hidden'; });
      root.classList.remove('is-grid');
      moveHead(true);
      gridEl.animate([{ opacity: 1 }, { opacity: 0 }], { duration: speed(300), easing: 'ease-out', fill: 'forwards' });
      stage.animate([{ opacity: 0, transform: 'scale(0.97)' }, { opacity: 1, transform: 'none' }],
        { duration: speed(460), delay: speed(80), easing: EASE, fill: 'backwards' });

      var left = fl.length;
      function landed() {
        if (--left > 0) return;
        gridEl.hidden = true;
        gridEl.getAnimations().forEach(function (a) { a.cancel(); });
        switching = false;
        showLabel(c);
        kick();
      }
      if (!left) { left = 1; landed(); }
      fl.forEach(function (p) {
        var f = makeFlyer(p.it.thumb, p.to, root, p.lead ? 'is-lead' : '');
        var frames = p.lead && !reduced
          ? [{ transform: T(p.from, p.to), easing: 'cubic-bezier(0.25, 0.75, 0.3, 1)' },
             { transform: T(grow(p.to, 1.04), p.to), offset: 0.7, easing: 'cubic-bezier(0.4, 0, 0.4, 1)' },
             { transform: 'none' }]
          : [{ transform: T(p.from, p.to), opacity: 1, filter: p.lead ? 'none' : 'blur(0px)' },
             { transform: 'none', opacity: p.lead ? 1 : p.op, filter: p.lead ? 'none' : 'blur(5px)' }];
        var a = f.animate(frames, { duration: speed(p.lead ? 620 : 520),
          easing: p.lead && !reduced ? 'linear' : EASE, fill: 'forwards' });
        a.onfinish = function () {
          p.it.el.style.visibility = '';
          p.gi.img.style.visibility = '';
          f.remove();
          landed();
        };
      });
    }

    // ------------------------------------------------------------------ focused pin
    // A little bigger than on the wheel, in the middle of the screen, over the dimmed grid.
    function focusBox(it) {
      var sq = Math.sqrt(it.ar);
      var maxW = wide ? Math.min(W * 0.62, 760) : W - 40;
      var maxH = H * (wide ? 0.6 : 0.5);
      var u = Math.min(maxW / sq, maxH * sq, U * (wide ? 1.35 : 1.25));
      var w = u * sq, h = u / sq, mid = H * (wide ? 0.45 : 0.42);
      return { x: (W - w) / 2, y: mid - h / 2, w: w, h: h };
    }
    function placeFocus() {
      if (!focusFlyer) return;
      var box = focusBox(focused.item), s = focusFlyer.style;
      s.left = box.x + 'px';
      s.top = box.y + 'px';
      s.width = box.w + 'px';
      s.height = box.h + 'px';
      focusLabel.style.top = (box.y + box.h + 30) + 'px';
    }

    function openFocus(i) {
      if (view !== 'grid' || switching || focused) return;
      var gi = gridItems[i], it = gi.item;
      focused = gi;
      haptics(true);
      var from = rectOf(gi.img), box = focusBox(it);
      focusName.textContent = it.name;
      focusDetail.textContent = it.detail;
      fillDate(focusDate, it.released);
      focusLabel.style.top = (box.y + box.h + 30) + 'px';
      focusEl.hidden = false;
      void focusEl.offsetWidth;
      focusEl.classList.add('is-open');
      gi.img.style.visibility = 'hidden';
      var f = focusFlyer = makeFlyer(it.thumb, box, focusEl);
      // press in, spring up past full size, settle
      var frames = reduced
        ? [{ transform: T(from, box) }, { transform: 'none' }]
        : [{ transform: T(from, box), easing: 'cubic-bezier(0.4, 0, 0.6, 1)' },
           { transform: T(grow(from, 0.9), box), offset: 0.14, easing: 'cubic-bezier(0.2, 0.8, 0.25, 1)' },
           { transform: T(grow(box, 1.045), box), offset: 0.7, easing: 'cubic-bezier(0.4, 0, 0.4, 1)' },
           { transform: 'none' }];
      f.animate(frames, { duration: speed(700), easing: reduced ? EASE : 'linear' });
      // swap in the full photo once it has loaded
      var im = new Image();
      im.onload = function () { if (focusFlyer === f) f.src = it.full; };
      im.src = it.full;
      try { focusClose.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }

    function closeFocus(instant) {
      if (!focused || closing) return;
      var gi = focused, f = focusFlyer, box = focusBox(gi.item), cell = rectOf(gi.img);
      closing = true;
      focusEl.classList.remove('is-open');
      function done() {
        f.remove();
        focusFlyer = null;
        focused = null;
        closing = false;
        focusEl.hidden = true;
        gi.img.style.visibility = '';
        if (!instant && !reduced) {
          gi.img.animate([{ transform: 'scale(1.05)' }, { transform: 'scale(0.98)' }, { transform: 'none' }],
            { duration: 320, easing: 'ease-out' });
        }
        try { gi.el.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      }
      if (instant) { done(); return; }
      var a = f.animate([{ transform: 'none' }, { transform: T(cell, box) }],
        { duration: speed(420), easing: 'cubic-bezier(0.3, 0.7, 0.2, 1)', fill: 'forwards' });
      a.onfinish = done;
    }

    // tap anywhere, scroll or swipe: the pin goes back to its place
    focusEl.addEventListener('click', function () { closeFocus(); });
    focusEl.addEventListener('wheel', function (e) { e.preventDefault(); closeFocus(); }, { passive: false });
    var touchY = null;
    focusEl.addEventListener('touchstart', function (e) { touchY = e.touches[0].clientY; }, { passive: true });
    focusEl.addEventListener('touchmove', function (e) {
      e.preventDefault();
      if (touchY !== null && Math.abs(e.touches[0].clientY - touchY) > 10) { touchY = null; closeFocus(); }
    }, { passive: false });

    viewBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        haptics(false);
        if (b.getAttribute('data-view') === 'grid') openGrid();
        else closeGrid();
      });
    });

    // ------------------------------------------------------------------ boot
    function refreshTheme() {
      shadowStrength = parseFloat(getComputedStyle(root).getPropertyValue('--shadow-strength')) || 1;
      render();
    }
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', refreshTheme);
    new MutationObserver(refreshTheme).observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme', 'data-scheme'] });
    reduceMQ.addEventListener('change', function () { reduced = reduceMQ.matches; render(); });

    if (window.ResizeObserver) new ResizeObserver(function () { layout(); render(); }).observe(root);
    // the headline is measured in its real typeface, so measure again once web fonts arrive
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { layout(); render(); });
    else window.addEventListener('resize', function () { layout(); render(); });

    layout();

    // Opening move: the wheel is already turning and comes to rest on the first pin.
    function intro() {
      if (reduced) {
        pos = 0;
        beginSnap(0);
      } else {
        pos = -4;
        release(9);
      }
      lastIdx = Math.round(pos);
      kick();
    }
    if (reduced) pos = 0;
    render();
    var first = items[0].img;
    var started = false;
    function startOnce() { if (!started) { started = true; intro(); } }
    // ?debug: drive the clock by hand (for testing in a hidden tab, where rAF is paused)
    if (location.search.indexOf('debug') !== -1) {
      window.qvm = {
        advance: function (sec) {
          for (var t = 0; t < sec; t += 1 / 60) step(1 / 60);
          render();
          return this.state();
        },
        state: function () {
          return { pos: +pos.toFixed(4), vel: +vel.toFixed(3), mode: mode, lift: +lift.toFixed(3),
            label: labelShown ? labelName.textContent : null };
        },
        wheel: function (dy) { root.dispatchEvent(new WheelEvent('wheel', { deltaY: dy, cancelable: true })); },
        release: function (v) { release(v); return this.state(); },
        set: function (p) { pos = p; mode = 'idle'; render(); },
        item: function (i) { var it = items[mod(i, M)]; return { src: it.src, fullReq: !!it.fullReq, fullFailed: it.fullFailed, ready: it.ready }; }
      };
    }
    setTimeout(prefetch, 900);
    if (first.complete && first.naturalWidth) setTimeout(startOnce, 150);
    else { first.addEventListener('load', function () { setTimeout(startOnce, 150); }, { once: true }); setTimeout(startOnce, 1500); }
  }

  function bootAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-qvm]'), boot);
  }
  bootAll();
  // Shopify's theme editor re-renders a section in place when its settings change
  document.addEventListener('shopify:section:load', bootAll);
})();
